<template>
    <div class="container">
        <vue-headful
                title="Newsletter Subscribers - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">Newsletter Subscribers</h3>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">Subscriber ID</th>
                                <th scope="col">Email</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="subscriber in subscribers" :key="subscriber.id">
                                <td>
                                    <button @click="deleteSubscriber(subscriber.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Contact"></button>
                                </td>
                                <th scope="row">
                                    {{subscriber.id}}
                                </th>
                                <td>
                                    {{subscriber.email}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card shadow pt-3 d-flex justify-content-center">
                    <pagination pagination="pagination"></pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";
import laravelPagination from "../components/LaravelPagination";

export default {
  data() {
    return {
      subscribers: {},
      pagination: {}
    };
  },
  mounted() {
    this.getAllSubscriber();
  },
  methods: {
    getAllSubscriber() {
      axios({
        method: "get",
        url:
          "admin/subscribers/all?access_token=" +
          localStorage.getItem("access_token"),
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            console.log(result.data.subscribers);
            this.subscribers = result.data.subscribers;
            this.pagination = {
              currentPage: result.data.subscribers.current_page,
              lastPage: result.data.subscribers.last_page,
              firstPageUrl: result.data.subscribers.first_page_url,
              lastPageUrl: result.data.subscribers.last_page_url,
              nextPageUrl: result.data.subscribers.next_page_url,
              previousPageUrl: result.data.subscribers.prev_page_url,
              perPage: result.data.subscribers.per_page,
              from: result.data.subscribers.from,
              to: result.data.subscribers.to,
              total: result.data.subscribers.total
            };
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteSubscriber(id) {
      axios({
        method: "delete",
        url: "admin/subscribers/delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Contact Request Deleted Successfully", "", "success");
            this.getAllContacts();
            console.log(result);
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful,
    pagination: laravelPagination
  }
};
</script>
<style>
</style>
